import { render, staticRenderFns } from "./short-list-backup.vue?vue&type=template&id=323e1ac8"
import script from "./short-list-backup.vue?vue&type=script&lang=js"
export * from "./short-list-backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports